module.exports = __webpack_public_path__ + "static/media/muzei.53f2f946.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Portfolio/images/platforms/muzei.png
 ** module id = 229
 ** module chunks = 0
 **/